export const validUrlAnchors = ['#dividends-table'];
